var _excluded = ["children", "className", "classes", "color", "data-testid", "disabled", "error", "helperText", "label", "onChange", "size", "style", "sx", "value", "variant"],
  _excluded2 = ["root", "icon", "iconOpen", "input", "paper", "select"];
var _styled;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { forwardRef, useState } from 'react';
import { textFieldClasses } from '@mui/material/TextField';
import { selectClasses } from '@mui/material/Select';
import { paperClasses } from '@mui/material/Paper';
import { any, arrayOf, bool, func, node, string, object, oneOf, oneOfType } from 'prop-types';
import clsx from 'clsx';
import { styled, useTheme } from '@mui/material/styles';
import SovosTextField from "../sovos-text-field";
var StyledSovosTextField = styled(SovosTextField)((_styled = {}, _defineProperty(_styled, "&.".concat(textFieldClasses.root), {
  width: '100%'
}), _defineProperty(_styled, "& .".concat(selectClasses.select), {
  '&:focus': {
    background: 'none'
  }
}), _styled));
var SovosSelect = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    classes = _ref.classes,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    dataTestId = _ref['data-testid'],
    disabled = _ref.disabled,
    error = _ref.error,
    helperText = _ref.helperText,
    label = _ref.label,
    onChange = _ref.onChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    style = _ref.style,
    sx = _ref.sx,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'filled' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = classes || {},
    root = _ref2.root,
    icon = _ref2.icon,
    iconOpen = _ref2.iconOpen,
    input = _ref2.input,
    paper = _ref2.paper,
    select = _ref2.select,
    classesRest = _objectWithoutProperties(_ref2, _excluded2);
  var _useTheme = useTheme(),
    shape = _useTheme.shape,
    shadows = _useTheme.shadows,
    spacing = _useTheme.spacing;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focusControl = _useState2[0],
    setFocusControl = _useState2[1];
  var handleKeyDown = function handleKeyDown() {
    return setFocusControl(true);
  };
  var getMenuStyles = function getMenuStyles() {
    var marginTop = spacing(0.25);
    if (variant === 'filled' && !label) {
      marginTop = size === 'small' ? spacing(1.75) : spacing(2.25);
    } else if (variant === 'outlined' && size === 'small') {
      marginTop = spacing(0.75);
    } else if (variant === 'standard') {
      marginTop = 0;
    }
    return _defineProperty({}, "& .".concat(paperClasses.root), {
      borderRadius: variant === 'filled' || variant === 'standard' ? "0 0 ".concat(shape.borderRadius, "px ").concat(shape.borderRadius, "px") : "".concat(shape.borderRadius, "px"),
      boxShadow: shadows[8],
      marginTop: marginTop,
      '& .MuiMenuItem-root': {
        '&:focus-visible': {
          outline: focusControl ? null : 'unset'
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement(StyledSovosTextField, {
    className: clsx('sovosSelect', className, root),
    color: color,
    "data-testid": dataTestId,
    disabled: disabled,
    error: error,
    helperText: helperText,
    InputProps: {
      classes: {
        root: input
      }
    },
    label: label,
    onChange: onChange,
    ref: ref,
    SelectProps: _objectSpread({
      classes: _objectSpread({
        icon: icon,
        iconOpen: iconOpen,
        select: select
      }, classesRest),
      displayEmpty: !label,
      MenuProps: {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        classes: {
          paper: paper
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        sx: getMenuStyles()
      }
    }, rest),
    select: true,
    size: size,
    style: style,
    sx: sx,
    value: value,
    variant: variant,
    onKeyDown: handleKeyDown
  }, children);
});
SovosSelect.propTypes = {
  /**
   * The content of the select. A collection of `SovosMenuItem`
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * One of the Material UI theme colors
   */
  color: oneOf(['primary']),
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * If `true`, the input is disabled
   */
  disabled: bool,
  /**
   * If `true`, the component will display an error state
   */
  error: bool,
  /**
   * Help text displays under the input
   */
  helperText: string,
  /**
   * The label of the input
   */
  label: string,
  /**
   * Callback fired when input value is changed `function(event: object) => void`
   */
  onChange: func,
  /**
   * Size of the Select
   */
  size: oneOf(['medium', 'small']),
  /**
   * Inline styles applied to the root element
   */
  style: object,
  /**
   * The system prop that allows defining system overrides as well as
   * additional CSS styles.
   */
  sx: oneOfType([arrayOf(oneOfType([func, object, bool])), func, object]),
  /**
   * Value of the Select
   */
  value: any,
  /**
   * Select variant
   */
  variant: oneOf(['filled', 'outlined', 'standard'])
};
SovosSelect.baseComponent = {
  name: 'Select',
  link: 'select/'
};
export default SovosSelect;